import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminSideBar from "../admin-page/AdminSideBar";
import "./dailyUpdate.css";

import {
  getMyDailyUpdatesApi,
  upsertMyDailyUpdateApi,
} from "../../redux/apiCalls/dailyUpdateApiCall";

function DailyUpdate() {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const { myDailyUpdates, loading, error } = useSelector(
    (state) => state.dailyUpdate
  );

  const today = useMemo(() => new Date().toISOString().split("T")[0], []);

  const [date, setDate] = useState(today);
  const [task, setTask] = useState("");
  const [done, setDone] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    // load last 7 days
    const to = today;
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 6);
    const from = fromDate.toISOString().split("T")[0];

    dispatch(getMyDailyUpdatesApi({ from, to }));
  }, [dispatch, today]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      upsertMyDailyUpdateApi({
        date,
        task,
        done,
        notes,
      })
    );
  };

  return (
    <main className="admin-page">
      <div className="admin-layout">
        <AdminSideBar />

        <section className="admin-main">
          <header className="admin-main-header">
            <h2 className="admin-main-title">Daily Update</h2>
            <p className="admin-main-subtitle">
              Share your task, what you finished, and any notes.
            </p>
          </header>

          <div className="admin-main-body daily-update-stack">
            <div className="daily-update-card">
              <div className="daily-update-user">
                <div className="daily-update-avatar">
                  <img src={user?.profilePicture?.url} alt="User profile" />
                </div>
                <div className="daily-update-user-info">
                  <h3 className="daily-update-username">{user?.userName}</h3>
                  <p className="daily-update-email">{user?.email}</p>
                </div>
              </div>

              <form className="daily-update-form" onSubmit={handleSubmit}>
                <div className="daily-update-row">
                  <div className="daily-update-field">
                    <label>Date</label>
                    <input
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                </div>

                <div className="daily-update-row">
                  <div className="daily-update-field">
                    <label>Task (today)</label>
                    <textarea
                      value={task}
                      onChange={(e) => setTask(e.target.value)}
                      placeholder="1) ...&#10;2) ..."
                      rows={4}
                    />
                  </div>
                </div>

                <div className="daily-update-row">
                  <div className="daily-update-field">
                    <label>Done</label>
                    <textarea
                      value={done}
                      onChange={(e) => setDone(e.target.value)}
                      placeholder="What did you finish?"
                      rows={4}
                    />
                  </div>
                </div>

                <div className="daily-update-row">
                  <div className="daily-update-field">
                    <label>Notes (optional)</label>
                    <textarea
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      placeholder="Anything blocking you?"
                      rows={3}
                    />
                  </div>
                </div>

                <div className="daily-update-actions">
                  <button className="btn primary" disabled={loading}>
                    {loading ? "Saving..." : "Save Update"}
                  </button>
                </div>

                {error && <p className="daily-update-error">{error}</p>}
              </form>
            </div>

            <div className="daily-update-history">
              <h3 className="daily-update-history-title">Last updates</h3>

              {myDailyUpdates && myDailyUpdates.length > 0 ? (
                myDailyUpdates.map((u) => (
                  <div key={u._id} className="daily-update-history-item">
                    <div className="daily-update-history-header">
                      <strong>{u.date}</strong>
                      <span className="daily-update-history-meta">
                        {u.userId?.userName}
                      </span>
                    </div>

                    <div className="daily-update-history-body">
                      <div className="daily-update-history-block">
                        <span className="daily-update-label">Task:</span>
                        <pre className="daily-update-text">{u.task}</pre>
                      </div>
                      <div className="daily-update-history-block">
                        <span className="daily-update-label">Done:</span>
                        <pre className="daily-update-text">{u.done}</pre>
                      </div>
                      {u.notes ? (
                        <div className="daily-update-history-block">
                          <span className="daily-update-label">Notes:</span>
                          <pre className="daily-update-text">{u.notes}</pre>
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))
              ) : (
                <p className="daily-update-empty">No updates yet.</p>
              )}
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default DailyUpdate;